// import * as d3 from 'Plugins/d3Plugin';
import * as d3 from 'd3';

export default function initUSAMap() {
	const activeClass = 'active-group';

	jQuery('.map-holder').each(function() {
		const holder = jQuery(this);
		let data = [];
		let json = {};

		async function loadMapData() {
			const resultData = await Promise.all([
				fetch(holder.data('states')),
				fetch(holder.data('map'))
			]);

			return resultData;
		}

		loadMapData().then((resultData) => {
			async function onLoad() {
				await resultData[0].json().then((res) => {
					json = res;
				});

				await resultData[1].json().then((res) => {
					data = res;
				});
			}

			onLoad().then(() => {
				onLoadData();
			});
		});

		var projection = d3.geoAlbersUsa()
			.scale(1350)
			.translate([487.5, 305]);

		var path = d3.geoPath()
			.projection(projection);

		var svg = d3.select(this)
			.append('svg')
			.attr('viewBox', [0, 0, 975, 610]);

		function onLoadData() {
			for (var i = 0; i < data.length; i++) {
				var dataState = data[i].state;
				var text = data[i].text;

				for (var j = 0; j < json.features.length; j++) {
					var jsonState = json.features[j].properties.name.toLowerCase();

					if (dataState.toLowerCase() === jsonState) {
						json.features[j].properties.value = true;

						svg.append('g')
							.attr('class', 'group')
							.attr('id', json.features[j].id);
					}
				}

				json.features[i].text = `<span class="title">${dataState}</span>
										<span class="description">${text}</span>`;
			}

			var tooltip = d3.select(holder[0])
				.append('div')
				.attr('class', 'map-tooltip')
				.style('opacity', 0);

			var mouseover = function(d) {
				tooltip.style('opacity', 1);
			};

			// var mousemove = function(d) {
			// 	tooltip
			// 		.html(d.text)
			// 		.style('top', (d3.mouse(holder[0])[1] - 5) + 'px');

			// 	if ((d3.mouse(holder[0])[0] + 227) > getWindowWidth()) {
			// 		tooltip
			// 			.style('left', (d3.mouse(holder[0])[0] - 183) + 'px');
			// 	} else {
			// 		tooltip
			// 			.style('left', (d3.mouse(holder[0])[0] + 27) + 'px');
			// 	}
			// };

			var mouseleave = function(d) {
				tooltip.style('opacity', 0);
			};
			const states = svg.selectAll('path')
				.data(json.features)
				.enter()
				.append('path')
				.attr('class', function(d) {
					if (d.properties.value) {
						return 'selected ' + d.properties.name;
					} else {
						return '';
					}
				})
				.attr('data-id', function(d) {
					return d.id;
				})
				.attr('data-search-term', function(d) {
					return d.properties.name.toLowerCase();
				})
				.attr('d', path)
				.style('stroke', function(d) {
					if (d.properties.value) {
						return holder.data('selected-border-color');
					} else {
						return holder.data('border-color');
					}
				})
				.style('stroke-width', '1')
				.style('fill', function(d) {
					if (d.properties.value) {
						return holder.data('selected-state-color');
					} else {
						return holder.data('state-color');
					}
				});

			holder.find('.selected').each(function() {
				const item = jQuery(this);
				const id = item.attr('data-id');
				const group = holder.find('#' + id);

				item.appendTo(group);
			});

			holder.find('.group').appendTo(holder.find('svg'));

			svg.selectAll('.group')
				.data(json.features)
				.on('mouseover', function(d) {
					d3.select(this)
					.raise()
					.transition()
					.duration(300)
					.selectAll('path')
					// .style('stroke', function(d) {
					// 	if (d.properties.value) {
					// 		return holder.data('selected-border-color');
					// 	} else {
					// 		return holder.data('border-color');
					// 	}
					// })
					.style('fill', holder.data('hover-state-color'));

					tooltip.html(d.text)
					mouseover();

					jQuery('[data-id="' + jQuery(this).attr('id') + '"]').addClass(activeClass);
				})
				// .on('mousemove', mousemove)
				.on('mouseout', function(d) {
					d3.select(this).selectAll('path')
					.transition()
					.duration(300)
					.style('fill', holder.data('selected-state-color'));

					mouseleave();

					jQuery('[data-id="' + jQuery(this).attr('id') + '"]').removeClass(activeClass);
				}).on('click', function(d) {
					// console.log(jQuery(d.text).html());
				})

				.on('click', function(d){
					var url = new URL(document.location),
					state = jQuery(d.text).html().toLowerCase();
					// url.searchParams.set('state', state);
					// window.location.href = url;
					//
					jQuery('.filtration-finder').find(`select[data-filter-group="state"]`).each(function() {
						const select = jQuery(this);
						const options = select.find('option');

						options.each(function(ind) {
							const option = jQuery(this);

							if (option.attr('value').trim().toLocaleLowerCase() === state) {
								select.prop('selectedIndex', ind);

								jcf.refresh(select);
								select.change();

								jQuery('html, body').animate({
									scrollTop: jQuery('.filtration-finder').offset().top
								}, 500);
							}
						});
					});
				});
		}
	});

	// function getWindowWidth() {
	// 	return typeof window.innerWidth === 'number' ? window.innerWidth : document.documentElement.clientWidth;
	// }
}
